import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "qty-box" };
const _hoisted_2 = ["min", "max"];
import Button from "../../../../components/Button.vue";
import { ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuantityBox',
    props: /*@__PURE__*/ _mergeModels({
        min: { type: Number, default: 1 },
        max: { type: Number }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const quantity = _useModel(__props, "modelValue");
        const quantityInput = ref();
        function increase() {
            if (quantity.value >= props.max) {
                quantity.value = props.max;
                return;
            }
            quantity.value++;
        }
        function decrease() {
            if (quantity.value <= props.min) {
                quantity.value = props.min;
                return;
            }
            quantity.value--;
        }
        function bump() {
            quantityInput.value.classList.remove('bump');
            setTimeout(() => quantityInput.value.classList.add('bump'));
        }
        watch(quantity, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                bump();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Button, {
                    icon: "minus",
                    onClick: decrease,
                    disabled: quantity.value <= 1
                }, null, 8 /* PROPS */, ["disabled"]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _withDirectives(_createElementVNode("input", {
                    class: "qty-box__input",
                    type: "number",
                    min: __props.min,
                    max: __props.max,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((quantity).value = $event)),
                    ref_key: "quantityInput",
                    ref: quantityInput
                }, null, 8 /* PROPS */, _hoisted_2), [
                    [_vModelText, quantity.value]
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createVNode(Button, {
                    icon: "add",
                    onClick: increase
                })
            ]));
        };
    }
});
